module.exports = __webpack_public_path__ + "img/user-icon.187b0a5.png";